import {Validators} from '@angular/forms';

import {TaxNumberValidator} from '@spa/validators';

import {ComponentTypesEnum} from '../../../../app/shared/enums';
import {BaseControl, CountryAutocompleteControl} from '../../../../app/shared/classes';

export const CompanyTaxDetailsFormArraySelector = 'companyTaxDetails';
export const CompanyTaxDetailsIdSelector = 'id';
export const CompanyTaxDetailsCountryIdSelector = 'countryId';
export const CompanyTaxDetailsTaxNumberSelector = 'taxNumber';

export const CompanyTaxDetailsTaxNumberMaxLength = 30;

export const CompanyTaxDetailsControls = (): BaseControl[] => {
    return [
        new BaseControl({
            name: CompanyTaxDetailsIdSelector,
            value: null,
            placeholder: '',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true,
            hidden: true
        }),
        new CountryAutocompleteControl({
            name: CompanyTaxDetailsCountryIdSelector,
            value: null,
            placeholder: 'Tax Country',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.CountryAutocomplete,
            options: [],
            countries: [],
            floatingLabelNever: true
        }),
        new BaseControl({
            name: CompanyTaxDetailsTaxNumberSelector,
            value: '',
            placeholder: 'Tax Number',
            validators: [Validators.maxLength(CompanyTaxDetailsTaxNumberMaxLength), TaxNumberValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        })
    ];
};
